
export enum ConnectionState {
  INITIAL = 'INITIAL',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  IDLE = 'IDLE'
}

export interface ConnectionStatus {
  state: ConnectionState;
  message: string;
}

export interface MetaAccount {
  id: string;
  name: string;
  status?: number; // 1=active, 2=disabled
}

export enum ConnectionMethod {
  FACEBOOK = 'facebook',
  OAUTH = 'oauth'
}

export interface MetaConnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (token: string) => void;
}

export enum MetaConnectStepEnum {
  INITIAL = 'INITIAL',
  ACCOUNT_SELECTION = 'ACCOUNT_SELECTION',
  SUCCESS = 'SUCCESS'
}

export type MetaConnectStep = keyof typeof MetaConnectStepEnum;
